import { AnimatedSidebar } from "../../../../components/interactives";
import { Button } from "../../../../components/basics/Button";
import { ButtonType } from "../../../../helpers/shared/buttonStyling";

interface IProps {
  show: boolean;
  onClose: () => void;
  contentType: string;
}

const TripTypeContent = () => {
  return (
    <>
      <h2 className="text-xl font-bold mb-4">Policy Type</h2>
      <h3 className="text-md font-bold mt-6">Single Trip</h3>
      <p>Refers to a round Trip departing from and returning to Singapore, up to 182 consecutive days in a row for each Trip.</p>
      <h3 className="text-md font-bold mt-6">Annual</h3>
      <p>
        Refers to multiple round Trips (up to 90 consecutive days in a row for each Trip) departing from and returning to Singapore, over a 12-month
        &nbsp;period from the “Starting from” date indicated.
      </p>
    </>
  );
};

const CoverTypeContent = () => {
  return (
    <>
      <h2 className="text-xl font-bold mb-4">Cover Type</h2>
      <h3 className="text-md font-bold mt-6">Group</h3>
      <p>refers to 2 or more Persons who can be related or unrelated Adults and Children who are travelling together on the same Trip.</p>
      <h3 className="text-md font-bold mt-6">Family</h3>
      <p>refers to You and/or your Spouse and your legal Children, step children and legally adopted children (up to 25 years old).</p>
    </>
  );
};

const FamilyTravellerInfo = () => {
  return (
    <>
      <h2 className="text-xl font-bold mb-4">Traveller(s)</h2>
      <h3 className="text-md font-bold mt-6">Adult(s)</h3>
      <p>Insured Person between the age of 18 and 80 years old.</p>
      <h3 className="text-md font-bold mt-6">Child(ren)</h3>
      <p>refers to a person who is</p>
      <ol className="py-1 list-alpha-parentheses-outside">
        <li>unmarried, and</li>
        <li>
          between 6 months and 18 years of age or up to 25 years of age if in full‐time education or has been accepted and is awaiting enrolment as a
          full time student in a recognized tertiary institution, and not engaged or serving in full‐time national service
        </li>
        <li>
          Children under individual, Group or Family cover are insured based on the sum insured for an Insured Child under Section 1, 2, 4 and 5.
        </li>
      </ol>
    </>
  );
};

const TravelRegionInfoContent = () => {
  return (
    <>
      <h2 className="text-xl font-bold mb-4">Region of Travel</h2>
      <h3 className="text-md font-bold mt-6">ASEAN</h3>
      <p>Brunei, Cambodia, Indonesia, Laos, Malaysia, Myanmar, Philippines, Thailand and Vietnam</p>
      <h3 className="text-md font-bold mt-6">Asia Pacific</h3>
      <p>
        ASEAN countries and Australia, Bangladesh, Bhutan, China, Hong Kong, India, Japan, South Korea, Macau, Maldives, Mongolia, Nepal, New Zealand,
        Pakistan, Sri Lanka, Taiwan and Tibet
      </p>
      <h3 className="text-md font-bold mt-6">Worldwide</h3>
      <p>Travel to or through any destinations in the world </p>
    </>
  );
};

const content = {
  "travel-region": TravelRegionInfoContent,
  travellers: CoverTypeContent,
  "trip-type": TripTypeContent,
  "family-travellers": FamilyTravellerInfo,
  "": TripTypeContent,
};

export const PolicyDetailsMoreInfo = ({ show, onClose, contentType }: IProps) => {
  return (
    <AnimatedSidebar show={show} onClose={onClose}>
      <div className="px-6 md:pt-14 md:px-18">
        {content[contentType as keyof typeof content]()}
        <Button className="mt-10" type={ButtonType.PRIMARY} onClick={onClose}>
          Back
        </Button>
      </div>
    </AnimatedSidebar>
  );
};
